import {ajax} from '../../helpers';

export const getPromo = (code) => {
  return ajax
    .get(`/promo_codes/search?code=${code}`)
    .then(response => response.data)
    .catch(error => console.log('getPromo error: ', error));
};
